
/**
 * 基础DOM查询库。。。
 */
function getWindow(){
    var win = {};
    if(typeof __VUE_SSR_CONTEXT__ === 'undefined') {
        try{
            if(top.window && top.window.document){
                win = top.window;
            }
        }catch(e){
            win = window;
        }
    }
    return win;
}
export function S(str,context){
    var win = context || getWindow();
    return win.document.getElementById(str);
}

export function SCN(str,context){
    var win = context || getWindow();
    return win.document.getElementsByClassName(str);
}
export function STN(str,context){
    var win = context || getWindow();
    return win.document.getElementsByTagName(str);
}
export const dom = S;
export const win = getWindow();

export default {
    S       : S,
    SCN     : SCN,
    STN     : STN,
    dom     : S,
    window  : getWindow()
};
